import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-select-cell-editor',
    template: `
    <div class="custom-renderer-ag">
        <select *ngIf="params.data.editFlag" multiple class="form-control form-ctrl" style="border-bottom: inherit !important;appearance: auto" [disabled]="params.node.data.isSelectDisabled" [(ngModel)]="selectedValue" (ngModelChange)="onValueChange($event)">
            <option *ngFor="let option of options" [value]="option.label">{{ option.label }}</option>
        </select>
        <div *ngIf="!params.data.editFlag" [innerText]="selectedValue"></div>
    </div>
  `,
})
export class SelectFieldRenderer implements ICellEditorAngularComp {
    params: any;
    public selectedValue: any;
    public options: any[];

    agInit(params: any): void {
        this.params = params;
        this.selectedValue = params.value ? params.value : "";
        this.options = params.colDef.cellEditorParams.options;
    }
    
    refresh(params: any) {
        this.params = params;
        this.selectedValue = params.value;
        return true;
    }

    getValue(): any {
        return this.selectedValue;
    }

    isPopup(): boolean {
        return true; // Return true if you want popup editing style
    }

    // Optional methods
    // You can add additional methods like focusIn, focusOut, etc. as needed

    onValueChange(newValue:any): void {
        this.params.setValue(newValue);
        // this.params.api.stopEditing();
    }

    // Implement other necessary methods from ICellEditorAngularComp interface
}
